<div class="container-fluid h-100 px-4 px-md-5">
  <div class="my-4">

    <div class="page-header">
      <button class="back-btn" (click)="goBack()" type="button">← Back</button>
      <h1>Errors</h1>
      <span *ngIf="project" class="project-name-badge">{{ project.name }}</span>
    </div>

    <div class="tabs">
      <button type="button" class="tab" [class.tab--active]="tab === 'issues'" (click)="selectTab('issues')">
        Issues
      </button>
      <button type="button" class="tab" [class.tab--active]="tab === 'setup'" (click)="selectTab('setup')">
        Setup
      </button>
    </div>

    <div *ngIf="loading" class="dashboard-loading">
      <div class="dashboard-spinner"></div>
    </div>

    <div *ngIf="!loading && error" class="state-msg state-msg--error">Failed to load error data.</div>

    <!-- ISSUES ---------------------------------------------------------- -->
    <ng-container *ngIf="!loading && !error && tab === 'issues'">

      <div class="stats-row" *ngIf="stats">
        <div class="stat-card">
          <span class="stat-card__label">Events (24h)</span>
          <span class="stat-card__value">{{ stats.events_last_24h | number }}</span>
        </div>
        <div class="stat-card">
          <span class="stat-card__label">Unresolved issues</span>
          <span class="stat-card__value">{{ stats.unresolved_issues | number }}</span>
        </div>
        <div class="stat-card">
          <span class="stat-card__label">Users affected</span>
          <span class="stat-card__value">{{ stats.users_affected | number }}</span>
        </div>
        <div class="stat-card">
          <span class="stat-card__label">Events (all time)</span>
          <span class="stat-card__value">{{ stats.total_events | number }}</span>
        </div>

        <div class="stat-card stat-card--chart" *ngIf="stats.daily_events?.length">
          <span class="stat-card__label">Last 14 days</span>
          <div class="sparkline">
            <div
              *ngFor="let day of stats.daily_events"
              class="sparkline__bar"
              [style.height.px]="barHeight(day.count)"
              [title]="formatDay(day.date) + ': ' + day.count + ' events'"></div>
          </div>
        </div>
      </div>

      <div class="filter-bar">
        <div class="segmented">
          <button type="button" [class.segmented__btn--active]="filters.status === 'unresolved'"
            class="segmented__btn" (click)="setStatusFilter('unresolved')">Unresolved</button>
          <button type="button" [class.segmented__btn--active]="filters.status === 'resolved'"
            class="segmented__btn" (click)="setStatusFilter('resolved')">Resolved</button>
          <button type="button" [class.segmented__btn--active]="filters.status === 'ignored'"
            class="segmented__btn" (click)="setStatusFilter('ignored')">Ignored</button>
          <button type="button" [class.segmented__btn--active]="filters.status === ''"
            class="segmented__btn" (click)="setStatusFilter('')">All</button>
        </div>

        <input
          class="form-control form-control-sm filter-bar__search"
          type="search"
          placeholder="Search error type, message or culprit…"
          [value]="filters.q"
          (change)="onSearchChange($any($event.target).value)" />

        <select
          class="form-select form-select-sm filter-bar__select"
          *ngIf="stats?.environments?.length"
          [value]="filters.environment"
          (change)="onEnvironmentChange($any($event.target).value)">
          <option value="">All environments</option>
          <option *ngFor="let env of stats.environments" [value]="env">{{ env }}</option>
        </select>

        <select
          class="form-select form-select-sm filter-bar__select"
          [value]="filters.sort"
          (change)="onSortChange($any($event.target).value)">
          <option value="last_seen">Last seen</option>
          <option value="first_seen">First seen</option>
          <option value="times_seen">Events</option>
        </select>
      </div>

      <div *ngIf="loadingIssues" class="state-msg">Loading issues…</div>

      <div *ngIf="!loadingIssues && issues.length === 0" class="empty-state">
        <p class="mb-2"><strong>No issues here.</strong></p>
        <p class="text-muted mb-3">
          Either your application is healthy, or it isn't reporting yet.
        </p>
        <button class="pw-btn pw-btn--ghost" type="button" (click)="selectTab('setup')">
          Set up error tracking
        </button>
      </div>

      <table *ngIf="!loadingIssues && issues.length > 0" class="table table-hover issues-table">
        <thead>
          <tr>
            <th>Issue</th>
            <th class="text-center issues-table__num">Events</th>
            <th class="text-center issues-table__num">Users</th>
            <th class="text-end issues-table__num issues-table__num--wide">Last seen</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let issue of issues" (click)="openIssue(issue)" class="issues-table__row">
            <td>
              <div class="issue-title">
                <span class="level-badge" [ngClass]="'level-badge--' + issue.level">{{ issue.level }}</span>
                <span class="issue-title__type">{{ issue.error_type || 'Message' }}</span>
                <span class="platform-badge">{{ issue.platform }}</span>
                <span class="status-badge" *ngIf="issue.status !== 'unresolved'"
                  [ngClass]="'status-badge--' + issue.status">{{ issue.status }}</span>
              </div>
              <div class="issue-value">{{ issue.value }}</div>
              <div class="issue-meta">
                <span *ngIf="issue.culprit">{{ issue.culprit }}</span>
                <span *ngIf="issue.environment" class="issue-meta__env">{{ issue.environment }}</span>
                <span *ngIf="issue.release">{{ issue.release }}</span>
              </div>
              <div class="issue-counts">
                {{ issue.times_seen | number }} {{ issue.times_seen === 1 ? 'event' : 'events' }}
                · {{ issue.users_seen | number }} {{ issue.users_seen === 1 ? 'user' : 'users' }}
                · {{ relativeTime(issue.last_seen) }}
              </div>
            </td>
            <td class="text-center count-cell issues-table__num">{{ issue.times_seen | number }}</td>
            <td class="text-center count-cell issues-table__num">{{ issue.users_seen | number }}</td>
            <td class="text-end text-muted issues-table__num issues-table__num--wide">{{ relativeTime(issue.last_seen) }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pagination-bar" *ngIf="!loadingIssues && totalPages > 1">
        <button class="pw-btn pw-btn--ghost" type="button" [disabled]="currentPage <= 1"
          (click)="goToPage(currentPage - 1)">Previous</button>
        <span class="text-muted">Page {{ currentPage }} of {{ totalPages }} · {{ issueCount }} issues</span>
        <button class="pw-btn pw-btn--ghost" type="button" [disabled]="currentPage >= totalPages"
          (click)="goToPage(currentPage + 1)">Next</button>
      </div>

    </ng-container>

    <!-- SETUP ----------------------------------------------------------- -->
    <ng-container *ngIf="!loading && !error && tab === 'setup'">

      <div class="setup-card">
        <h2 class="setup-card__title">Ingest keys</h2>
        <p class="text-muted setup-card__hint">
          A key only allows appending events to this project — it can never read them, so it is safe to
          ship inside a browser bundle.
        </p>

        <table class="table keys-table" *ngIf="keys.length">
          <thead>
            <tr>
              <th>Name</th>
              <th>Ingest URL</th>
              <th class="text-end">Last used</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let key of keys">
              <td>
                {{ key.name || 'Key' }}
                <span class="platform-badge">{{ key.platform }}</span>
              </td>
              <td>
                <code class="ingest-url">{{ key.ingest_url }}</code>
                <button class="copy-btn" type="button" (click)="copy(key.ingest_url, key.uuid)">
                  {{ copiedKey === key.uuid ? 'Copied' : 'Copy' }}
                </button>
              </td>
              <td class="text-end text-muted">
                {{ key.last_used_at ? relativeTime(key.last_used_at) : 'never' }}
              </td>
            </tr>
          </tbody>
        </table>

        <div class="token-row" *ngIf="keys.length">
          <div>
            <strong class="token-row__label">Upload token</strong>
            <p class="text-muted token-row__hint mb-0">
              Secret. Used by your build pipeline to upload source maps — never put it in a browser bundle.
            </p>
          </div>
          <div class="token-row__value">
            <code class="ingest-url">{{ showSecret ? uploadToken : '••••••••••••••••••••••••' }}</code>
            <button class="copy-btn" type="button" (click)="showSecret = !showSecret">
              {{ showSecret ? 'Hide' : 'Reveal' }}
            </button>
            <button class="copy-btn" type="button" (click)="copy(uploadToken, 'token')">
              {{ copiedKey === 'token' ? 'Copied' : 'Copy' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Source maps -->
      <div class="setup-card">
        <h2 class="setup-card__title">Source maps</h2>
        <p class="text-muted setup-card__hint">
          Without them, a production Angular stack trace points at <code>main-K3X.js:1:48213</code>.
          With them, PulseWatch resolves each frame to your TypeScript — before grouping, so an issue
          survives the next deploy's bundle hashes.
        </p>

        <div class="upload-row">
          <input class="form-control form-control-sm upload-row__release" type="text"
            placeholder="Release, e.g. 1.4.2" [(ngModel)]="uploadRelease" name="uploadRelease" />
          <label class="pw-btn pw-btn--ghost upload-row__button">
            {{ uploading ? 'Uploading…' : 'Upload .js.map files' }}
            <input type="file" accept=".map,application/json" multiple hidden
              [disabled]="uploading" (change)="onSourceMapSelected($event)" />
          </label>
        </div>

        <table class="table keys-table" *ngIf="sourceMaps.length">
          <thead>
            <tr>
              <th>Release</th>
              <th>Bundle</th>
              <th class="text-end">Size</th>
              <th class="text-end">Uploaded</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let artifact of sourceMaps">
              <td>{{ artifact.release }}</td>
              <td><code class="ingest-url">{{ artifact.name }}</code></td>
              <td class="text-end text-muted">{{ formatSize(artifact.size) }}</td>
              <td class="text-end text-muted">{{ relativeTime(artifact.created_at) }}</td>
              <td class="text-end">
                <button class="copy-btn" type="button" (click)="deleteSourceMap(artifact)">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>

        <p class="text-muted setup-card__hint" *ngIf="!sourceMaps.length">
          No source maps uploaded yet.
        </p>

        <p class="setup-step">Uploading from CI instead:</p>
        <pre class="snippet">{{ sourceMapUploadSnippet }}</pre>
      </div>

      <div class="setup-card">
        <h2 class="setup-card__title">Install the SDK</h2>

        <div class="segmented segmented--platforms">
          <button type="button" class="segmented__btn"
            [class.segmented__btn--active]="snippetPlatform === 'angular'"
            (click)="snippetPlatform = 'angular'">Angular</button>
          <button type="button" class="segmented__btn"
            [class.segmented__btn--active]="snippetPlatform === 'django'"
            (click)="snippetPlatform = 'django'">Django</button>
        </div>

        <ng-container *ngIf="snippetPlatform === 'angular'">
          <p class="setup-step">1. Download the SDK and unzip it into <code>src/app/</code>, so it lands in
            <code>src/app/pulsewatch/</code>.</p>
          <a class="pw-btn pw-btn--ghost setup-download" href="/assets/downloads/pulsewatch-angular-sdk.zip"
            download>Download Angular SDK (.zip)</a>
          <p class="setup-step">2. Register it once at bootstrap:</p>
          <pre class="snippet">{{ angularSnippet }}</pre>
          <p class="setup-step">
            That replaces Angular's <code>ErrorHandler</code>, so every uncaught error and unhandled
            promise rejection is reported with its stack trace.
          </p>
        </ng-container>

        <ng-container *ngIf="snippetPlatform === 'django'">
          <p class="setup-step">1. Download the SDK and unzip it next to <code>manage.py</code>, so
            <code>pulsewatch_sdk/</code> is importable.</p>
          <a class="pw-btn pw-btn--ghost setup-download" href="/assets/downloads/pulsewatch-django-sdk.zip"
            download>Download Django SDK (.zip)</a>
          <p class="setup-step">2. Configure it in your settings:</p>
          <pre class="snippet">{{ djangoSnippet }}</pre>
          <p class="setup-step">
            Put the middleware first so it sees exceptions raised by everything below it. Passwords,
            tokens and authorization headers are stripped before an event leaves your process.
          </p>
          <p class="setup-step">
            With <code>traces_sample_rate</code> above zero, that same middleware records what each
            request did — every query, who made it, how long it took — under
            <a [routerLink]="['/main', 'project', projectId, 'tracing']">Tracing</a>.
          </p>
        </ng-container>

        <p class="setup-step">Send a test event from the shell:</p>
        <pre class="snippet">{{ curlSnippet }}</pre>
      </div>

    </ng-container>

  </div>
</div>
